<template>
  
  <Head>
  <title>Setup - MealType & Age/Grade & Days | NutriStudents K-12</title>
  <meta name="description" content="Setup - MealType, Age/Grade, Days">
  </Head>

  <default-layout>
    <BreadcrumLayout>
      <!-- <a href="#" class="link-color"> --><U>Settings</U><!-- </a> -->
    </BreadcrumLayout>
    <PageTitleLayout>
      <div class="lg:mb-0 mb-4">
        <h1 class="heading-color xl:text-4xl text-2xl font-bold">Setup</h1>
      </div>
      <div class="w-full flex lg:flex-nowrap flex-wrap justify-end items-center" >

        <button v-if="$page.props.isUserSuperAdmin" @click="addMealTypeModalOpen" class="button-color text-white font-bold py-3 xl:px-4 px-2 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 mt-10">          
          ADD MEALTYPE          
        </button>
            
        <button v-if="$page.props.isUserSuperAdmin" @click="addAgeGradeModalOpen" class="button-color text-white font-bold py-3 xl:px-4 px-2 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 mt-10">          
          ADD AGE/GRADE OFFERING
        </button>
      
        <button v-if="$page.props.isUserSuperAdmin" @click="addDaysModalOpen" class="button-color text-white font-bold py-3 xl:px-4 px-2 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 mt-10">          
          ADD DAYS OFFERED
        </button>

      </div>
    </PageTitleLayout>

    <!-- <TableFilterLayout @messageFromChild="siteSearchData" /> -->

    <TableIndexLayout>
      <div class="">
        <div class="searching xl:px-10 px-5 md:pt-10 pt-8 w-full">
          <header class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg">
            <div class="text-lg text-white">
              Meals Offered
            </div>
            <a v-if="$page.props.isUserSuperAdmin" href="#" @click="addMealTypeModalOpen">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-6 text-white" viewBox="0 0 24 24" stroke="currentColor" fill="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
              </svg>
            </a>
          </header>
        </div>
        <div class="-my-2">
          <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full">
            <div class="shadow overflow-x-auto">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="header-bg-color">
                  <tr>
                    <th scope="col" colspan="2" class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                      MEAL TYPE
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">

                 <tr v-if="!mealTypes.length" class="bg-white">
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="7">No Meal Types Found</td>
                 </tr>

                  <tr v-for="(mealtype,index) in mealTypes" class="bg-white">
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400">{{mealtype.name}}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-gray-400 text-xl font-extrabold">
                      
                      <div class="flex items-center w-full justify-end" v-if="$page.props.isUserSuperAdmin && mealtype.is_tenant_admin_master">
                        <a href="#" @click="mealtype_edit_script(mealtype.id)">
                        <i class="fa fa-pencil-square-o pr-3" aria-hidden="true"></i>  
                        </a>
                        <button type="button" @click="mealtype_delete_script(mealtype.id)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </div>
                    </td>
                  </tr>                           


                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="">
        <div class="searching xl:px-10 px-5 md:pt-10 pt-8 w-full">
          <header class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg">
            <div class="text-lg text-white">
              Age/Grade Offering
            </div>
            <a v-if="$page.props.isUserSuperAdmin " href="#" @click="addAgeGradeModalOpen">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-6 text-white" viewBox="0 0 24 24" stroke="currentColor" fill="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
              </svg>
            </a>
          </header>
        </div>
        <div class="-my-2">
          <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full">
            <div class="shadow overflow-x-auto">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="header-bg-color">
                  <tr>
                    <th scope="col" class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                      Name
                    </th>
                    <th scope="col" class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                      Starting
                    </th>
                    <th scope="col" class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                      End
                    </th>
                    <th scope="col" class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                      &nbsp;
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">

                  <tr v-if="!ageGrades.length" class="bg-white">
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="7">No Age/Grade Offering Found</td>
                  </tr>

                  <tr v-for="(agegrade,index) in ageGrades" class="bg-white">
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400">{{agegrade.name}}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold">{{agegrade.starting}}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold">{{agegrade.ending}}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-gray-400 text-xl font-extrabold">
                      <div v-if="$page.props.isUserSuperAdmin && agegrade.is_tenant_admin_master" class="flex items-center w-full justify-end">
                        <a href="#" @click="agegrade_edit_script(agegrade.id)" class="inline-block mr-5">
                          <i class="fa fa-pencil-square-o pr-3" aria-hidden="true"></i>
                        </a>
                        <button type="button" @click="agegrade_delete_script(agegrade.id)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                        </button>                        
                      </div>
                    </td>
                  </tr>                  
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-10">
        <div class="searching xl:px-10 px-5 md:pt-10 pt-8 w-full">
          <header class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg">
            <div class="text-lg text-white">
              Days Offered
            </div>
            <a v-if="$page.props.isUserSuperAdmin" href="#" @click="addDaysModalOpen">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-6 text-white" viewBox="0 0 24 24" stroke="currentColor" fill="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
              </svg>
            </a>
          </header>
        </div>
        <div class="-my-2">
          <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full">
            <div class="shadow overflow-x-auto">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="header-bg-color">
                  <tr>
                    <th scope="col" class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                      Name
                    </th>
                    <th scope="col" class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                      Days
                    </th>
                    <th scope="col" class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                      &nbsp;
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  
                  <tr v-if="!Days.length" class="bg-white">
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="7">No Days Found</td>
                  </tr>

                  <tr v-for="(day, index) in Days" class="bg-white">
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400">{{day.name}}</td>
                    
                    <td>
                    <div class="flex">
                    <div v-if="day.mon" class="px-6 py-4 whitespace-nowrap text-base font-bold">MON</div>
                    <div v-if="day.tue" class="px-6 py-4 whitespace-nowrap text-base font-bold">TUE</div>
                    <div v-if="day.wed" class="px-6 py-4 whitespace-nowrap text-base font-bold">WED</div>
                    <div v-if="day.thu" class="px-6 py-4 whitespace-nowrap text-base font-bold">THU</div>
                    <div v-if="day.fri" class="px-6 py-4 whitespace-nowrap text-base font-bold">FRI</div>
                    <div v-if="day.sat" class="px-6 py-4 whitespace-nowrap text-base font-bold">SAT</div>
                    <div v-if="day.sun" class="px-6 py-4 whitespace-nowrap text-base font-bold">SUN</div>
                    </div>
                    </td>

                    <td class="px-6 py-4 whitespace-nowrap text-gray-400 text-xl font-extrabold">
                      <div v-if="$page.props.isUserSuperAdmin" class="flex items-center w-full justify-end">
                        
                        <a href="#" @click="days_edit_script(day.id)" class="inline-block mr-5"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>

                        <button type="button" @click="days_delete_script(day.id)">
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </button>

                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      
    </TableIndexLayout>


    <TableIndexLayout>
      <div class="">
        <div class="searching xl:px-10 px-5 md:pt-10 pt-8 w-full">
          <header class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg">
            <div class="text-lg text-white">
              Application Content
            </div>
          </header>
        </div>
        <div class="-my-2">
          <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full">
            <div class="shadow overflow-x-auto">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="header-bg-color">
                  <tr>
                    <th scope="col"  class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                       TYPE
                    </th>
                    <th scope="col" colspan="2" class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                       Source
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  <tr v-for="(cs,index) in formClient.clientSettingArray" class="bg-white" >
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400">  {{ cs.type }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400">  {{ cs.source }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400"> 
                      <label  class="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" @change="addClinetData" :disabled="!$page.props.isUserSuperAdmin || (cs.type == 'Products' && cs.source == 'Manufacturer') " v-model="cs.status" value="1" class="sr-only peer">
                  <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
  <!-- <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">Toggle me</span> -->
</label>
                    </td>                    
                  </tr>                           


                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      </TableIndexLayout>


      <TableIndexLayout>
      <div class="">
        <div class="searching xl:px-10 px-5 md:pt-10 pt-8 w-full">
          <header class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg">
            <div class="text-lg text-white">
              Offer vs Serve Logic
            </div>
          </header>
        </div>
        <div class="-my-2">
          <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full">
            <div class="shadow overflow-x-auto">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="header-bg-color">
                  <tr>
                    <th scope="col"  class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                       TYPE
                    </th>
                    <th scope="col" colspan="2" class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                       Description
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  <tr  class="bg-white">
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400">Milk</td>
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400">IF the logic is enabled on the setup screen, then the week cycle will credit the following average</td>
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400"> 
                      <label class="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" :disabled="!$page.props.isUserSuperAdmin" @change="changeMilk"  v-model="milk" value="1" class="sr-only peer">
                        <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                      </label>
                    </td>                    
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      </TableIndexLayout>


      


      <TableIndexLayout>
      <div class="">
        <div class="searching xl:px-10 px-5 md:pt-10 pt-8 w-full">
          <header class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg">
            <div class="text-lg text-white">
              Shared Options
            </div>
          </header>
        </div>
        <div class="-my-2">
          <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full">
            <div class="shadow overflow-x-auto">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="header-bg-color">
                  <tr>
                    <th scope="col"  class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                       Shared Option Name
                    </th>
                    <th scope="col" colspan="2" class=" px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                      Color
                    </th>
                  </tr>
                </thead>
                <tbody class=" divide-gray-200">
                  <tr  class="bg-white" v-for="(sharedOption,index) in sharedOptions">
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400">{{ index }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400"> {{ sharedOption }} </td>
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400"> 
                      <input type="color" v-model="sharedOptions[index]" @change="changeSharedOption" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                    </td>                    
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      </TableIndexLayout>


      <TableIndexLayout v-if="$page.props.is_ns_admin">
      <div class="">
        <div class="searching xl:px-10 px-5 md:pt-10 pt-8 w-full">
          <header class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg">
            <div class="text-lg text-white">
              Allow import on past weeks
            </div>
          </header>
        </div>
        <div class="-my-2 mb-3" >
          <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full">
            <div class="shadow overflow-x-auto">
              <table class="min-w-full divide-y divide-gray-200">
                
                <tbody class="divide-y divide-gray-200">
                  <tr  class="bg-white">
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400">Allow import on past weeks</td>
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400">&nbsp</td>
                    <td class="px-6 py-4 whitespace-nowrap text-base font-bold text-blue-400"> 
                      <label class="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox"  @change="changeAllowImportPastWeek"  v-model="isAllowImportPastWeek" value="1" class="sr-only peer">
                        <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                      </label>
                    </td>                    
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      </TableIndexLayout>


  </default-layout>  


  <MealTypeModal v-if="openMealTypeModal" :openMealTypeModal="openMealTypeModal" :editMealType="editMealType" @closeModal="closeModalMealType"/>

  <AgeGradeModal v-if="openAgeGradeModal" :openAgeGradeModal="openAgeGradeModal" :editAgeGrade="editAgeGrade" @closeModalAG="closeModalAgeGrade"/>

  <DaysModal v-if="openDaysModal" :openDaysModal="openDaysModal" :editDays="editDays" @closeModalDays="closeModalDayss"/>  

</template>
<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import Welcome from "@/Jetstream/Welcome";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";

import MealTypeModal from "@/Pages/Setup/MealType";
import AgeGradeModal from "@/Pages/Setup/AgeGrade";
import DaysModal from "@/Pages/Setup/Days";

export default {
  props:['mealtypes','agegrades','days', 'clientSettingArray', 'is_milk', 'shared_letters', 'is_allow_import_past_week'],
  components: {
    DefaultLayout,
    Welcome,
    BreadcrumLayout,
    PageTitleLayout,
    TableFilterLayout,
    TableIndexLayout,
    MealTypeModal,
    AgeGradeModal,
    DaysModal
  },
  data(){
    return {
      mealTypes:this.mealtypes,
      ageGrades:this.agegrades,
      Days:this.days,
      sharedOptions: this.shared_letters,

      openMealTypeModal:false,
      openAgeGradeModal:false,
      openDaysModal:false,

      editMealType:'',
      editAgeGrade:'',
      editDays:'',
      milk : this.is_milk,
      isAllowImportPastWeek : this.is_allow_import_past_week,

      form: this.$inertia.form({
        
      }),

      formClient: this.$inertia.form({
        clientSettingArray:this.clientSettingArray
      })
    }
  },
  methods:{   

    addClinetData(){
      console.log("addClinetData");
        this.formClient.post(this.route('client-setting-store'), {
          preserveScroll: true,
            onSuccess: () => {    
              this.$toast.success('Client setting has been updated successfully!');
            },
          });
      },
      changeMilk(){
        console.log("changeMilk" , this.milk);
        axios.post('/change-milk-setting',{milk:this.milk})
        .then((response)=>{
          // this.$toast.success('Milk setting has been successfully updated');
        }).catch(error => console.error(error));
      },
      changeAllowImportPastWeek(){
        // console.log("changeAllowImportPastWeek" , this.isAllowImportPastWeek);
        axios.post('/change-allow-import-past-week',{isAllowImportPastWeek:this.isAllowImportPastWeek})
        .then((response)=>{
          // this.$toast.success('Milk setting has been successfully updated');
        }).catch(error => console.error(error));
      },

      changeSharedOption(){
        console.log("changeSharedOption" , this.sharedOptions);
        axios.post('/setup-change-shared-option',{sharedOptions:this.sharedOptions})
        .then((response)=>{
          // this.$toast.success('Milk setting has been successfully updated');
        }).catch(error => console.error(error));
      },

  addMealTypeModalOpen() {
    this.openMealTypeModal = true;
  },
  closeModalMealType() {
    this.openMealTypeModal = false;
  },

  mealtype_edit_script(mtid){    
    axios.post('/edit-mealtype',{id:mtid})
        .then((response)=>{
        this.editMealType = response.data;        
        this.openMealTypeModal = true;
        }).catch(error => console.error(error));
  },

  saveSharedOption(mtid){    
    axios.post('/save-shared-option',{id:mtid})
        .then((response)=>{
        this.editMealType = response.data;        
        this.openMealTypeModal = true;
        }).catch(error => console.error(error));
  },

  mealtype_delete_script(mtid){
    if(confirm("Deleting this item may disrupt your Week Cycles and cannot be undone. Are you sure you want to proceed?")){
          this.form.post(this.route('delete-mealtype', mtid), {
                onSuccess: () => {
                  this.$toast.success('Meal Type deleted successfully!');
                  setTimeout(function(){
                    window.location.reload();
                  }, 1000);
                }
          });
    }
  },

  addAgeGradeModalOpen() {
    this.openAgeGradeModal = true;
  },
  closeModalAgeGrade() {
    this.openAgeGradeModal = false;
  },
  agegrade_edit_script(agid){    
    axios.post('/edit-agegrade-offering',{id:agid})
        .then((response)=>{
        this.editAgeGrade = response.data;        
        this.openAgeGradeModal = true;
        }).catch(error => console.error(error));
  },

  agegrade_delete_script(agid){
    if(confirm("Deleting this item may disrupt your Week Cycles and cannot be undone. Are you sure you want to proceed?")){
          this.form.post(this.route('delete-agegrade-offering', agid), {
                onSuccess: () => {
                  this.$toast.success('Age/Grade offering deleted successfully!');
                  setTimeout(function(){
                    window.location.reload();
                  }, 1000);
                }
          });
    }
  },

  
  addDaysModalOpen() {
    this.openDaysModal = true;
  },
  closeModalDayss() {
    this.openDaysModal = false;
  },             
  days_edit_script(did){    
    axios.post('/edit-days',{id:did})
        .then((response)=>{
        this.editDays = response.data;        
        this.openDaysModal = true;
        }).catch(error => console.error(error));
  },

  days_delete_script(did){
    if(confirm("Are you sure you want to delete this day?")){
          this.form.post(this.route('delete-days', did), {
                onSuccess: () => {
                  this.$toast.success('Day offered deleted successfully!');
                  setTimeout(function(){
                    window.location.reload();
                  }, 1000);
                }
          });
    }
  },              

  },
};
</script>
<style>
.id_arrow .fa-sort-desc:before {
    content: "\f0dd";
    position: absolute;
    top: 17px;
    left: 43px;
    padding-left:7px;
    color: #219FD5;
}

.id_arrow .fa-sort-asc:before {
    content: "\f0de";
    color: #219FD5;
    padding-left:7px;
    position: absolute;
    top: 17px;
    left: 43px;
}
.select-menu-height-edit2 {
    height: 2.8rem;
}

.validation_error_msg {
    font-weight: 400;
    margin: 6px 0 0 !important;
    color: red;
}

td.text-gray-400 {
    color: #0092d0;
}
</style>
